import { render, staticRenderFns } from "./Bookmanagement.vue?vue&type=template&id=e564b284&scoped=true"
import script from "./Bookmanagement.vue?vue&type=script&lang=js"
export * from "./Bookmanagement.vue?vue&type=script&lang=js"
import style0 from "./Bookmanagement.vue?vue&type=style&index=0&id=e564b284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e564b284",
  null
  
)

export default component.exports